import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './i18n/i18n'
import VueEasyLightbox from 'vue-easy-lightbox'

Vue.use(VueEasyLightbox)

Vue.config.productionTip = false

new Vue({
	router,
	store,
	vuetify,
	i18n,
	render: h => h(App)
}).$mount('#app')
